import { makeStyles } from 'tss-react/mui';
import { colors, theme } from './theme';

/**
 * Custom hook that defines the global styles for the application.
 * @returns An object containing the class names for the global styles.
 */
const useGlobalStyles = makeStyles()(() => ({
  h1: {
    fontSize: theme.fontSize.h1,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.bold,
  },
  h2: {
    fontSize: theme.fontSize.h2,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.bold,
  },
  h3: {
    fontSize: theme.fontSize.h3,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.bold,
  },
  h4: {
    fontSize: theme.fontSize.h4,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.medium,
  },
  h5: {
    fontSize: theme.fontSize.h5,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.medium,
  },
  h6: {
    fontSize: theme.fontSize.h6,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.medium,
  },
  p: {
    fontSize: theme.fontSize.default,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeight.regular,
  },
  input: {
    'padding': theme.padding.s,
    'fontSize': theme.fontSize.default,
    'fontFamily': theme.fontFamily,
    'width': '100%',
    'border': theme.border,
    'borderRadius': theme.borderRadius.s,
    'outline': 'none',
    'boxSizing': 'border-box',
    '&:focus': {
      borderColor: theme.borderColor,
      boxShadow: theme.buttonShadow(theme.borderColor),
    },
  },
  container: {
    padding: theme.padding.m,
    backgroundColor: colors.white,
  },
  button: {
    'textTransform': 'none',
    'padding': `${theme.padding.xs} ${theme.padding.m}`,
    'fontSize': theme.fontSize.default,
    'fontWeight': theme.fontWeight.medium,
    'fontFamily': theme.fontFamily,
    'backgroundColor': theme.primary.light,
    'color': theme.text.primary.dark,
    'border': `1px solid ${theme.primary.light}`,
    'borderRadius': theme.borderRadius.s,
    'cursor': 'pointer',
    'height': 'fit-content',
    'margin': `0 ${theme.margin.m} 0 ${theme.margin.m}`,
    '&:hover': {
      backgroundColor: theme.primary.dark,
      borderColor: theme.primary.dark,
    },
    '&:active': {
      backgroundColor: theme.primary.darker,
      boxShadow: theme.buttonShadow(theme.primary.darker),
      borderColor: theme.primary.darker,
    },
  },
  mandatoryField: {
    color: colors.red['400'],
    marginLeft: theme.margin.xs,
    fontWeight: theme.fontWeight.medium,
    fontFamily: theme.fontFamily,
  },
  indicatesMandatoryText: {
    fontSize: theme.fontSize.smaller,
    fontWeight: theme.fontWeight.medium,
    fontFamily: theme.fontFamily,
  },
  error: {
    fontFamily: theme.fontFamily,
    color: colors.red['400'],
    marginBottom: theme.margin.m,
    fontSize: theme.fontSize.smallest,
    marginTop: theme.margin.xs,
    fontWeight: theme.fontWeight.medium,
    marginLeft: theme.margin.xs,
  },
  notExist: {
    fontFamily: theme.fontFamily,
    fontStyle: 'italic',
    color: colors.gray['400'],
    fontSize: theme.fontSize.smaller,
  },
  divider: {
    border: theme.border,
    borderColor: colors.gray['200'],
    margin: `${theme.margin.l} ${theme.margin.s}`,
  },
  tooltip: {
    backgroundColor: colors.black,
    color: colors.white,
    borderRadius: theme.borderRadius.m,
    fontSize: theme.fontSize.smallest,
    whiteSpace: 'nowrap',
    fontFamily: theme.fontFamily,
    top: `-${theme.padding.l}`,
  },
  userAvatar: {
    border: `1.5px solid ${colors.black}`,
    marginRight: '10px',
  },
  modal: {
    'position': 'absolute',
    'top': '50%',
    'left': '50%',
    'transform': 'translate(-50%, -50%)',
    'width': 'fit-content',
    'backgroundColor': colors.white,
    'padding': theme.padding.l,
    'borderRadius': theme.borderRadius.s,
    'border': 'none',
    'boxShadow': `2px 2px 5px 5px ${colors.gray['400']}`,
    '&:focus': {
      outline: 'none',
    },
  },
  modalHeader: {
    marginBottom: theme.margin.l,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  closeButton: {
    cursor: 'pointer',
    height: '30px',
    width: '30px',
  },
}));

export default useGlobalStyles;
